import { render, staticRenderFns } from "./userForm.vue?vue&type=template&id=639b1eb6&scoped=true"
import script from "./userForm.vue?vue&type=script&lang=js"
export * from "./userForm.vue?vue&type=script&lang=js"
import style0 from "./userForm.vue?vue&type=style&index=0&id=639b1eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b1eb6",
  null
  
)

export default component.exports